import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Select, styled } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useGetVerticalsQuery } from "../../store/apis/search";
import FilterListItem from "../FilterListItem";
import colors from "../../theme/colors";

export interface VerticalFilterProps {
  title: string;
  name?: string;
  tooltip?: string;
  value: number[];
  placeholder?: string;
  open?: boolean;
  loading?: boolean;
  icon?: React.ReactNode;
  setOpen: (value: boolean) => void;
  onChange: (value: any[]) => void;
}

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  margin: theme.spacing(1),
  minWidth: "100%",
}));

const VerticalsFilter: React.FC<VerticalFilterProps> = ({
  title = "verticals",
  name = "verticals-filter",
  tooltip,
  value = [],
  open,
  icon,
  setOpen,
  onChange,
}) => {
  const { data: verticalsData, isLoading: isVerticalsLoading } = useGetVerticalsQuery();
  const verticalsOptions = useMemo(() => verticalsData ?? [], [verticalsData]);

  const [verticalValue, setverticalValue] = useState(0);
  const [subVerticalValue, setsubVerticalValue] = useState(0);

  useEffect(() => {
    if (!value?.length || !verticalsOptions.length) return;

    let foundVertical = verticalsOptions.find(option => option.id === value[0]);
    if (!foundVertical) {
      //if not found in verticals look in subverticals
      foundVertical = verticalsOptions.find(vertical => {
        return vertical.subvertical.some(item => {
          return item.id === value[0];
        });
      });
    }
    const foundVerticalId = foundVertical?.id ?? 0;
    setverticalValue(foundVerticalId);
    // if its subvertical
    if (foundVertical?.id !== value[0]) {
      setsubVerticalValue(value[0] ?? 0);
    }
  }, [verticalsOptions, value]);

  const handleChange = (event: any) => {
    setverticalValue(event.target.value);
    setsubVerticalValue(0);
    onChange([event.target.value]);
  };

  const handleChange2 = (event: any) => {
    setsubVerticalValue(event.target.value);
    onChange([event.target.value]);
  };
  const handleReset = (event: any) => {
    setverticalValue(0);
    setsubVerticalValue(0);
    onChange([]);
  };

  const listSubverticals = () => {
    const selectedVertical = verticalsOptions.find(option => option.id === verticalValue);
    const subverticals = selectedVertical?.subvertical;
    return subverticals ?? [];
  };

  const verticalSelectValue = verticalValue === 0 ? "" : verticalValue.toString();
  const subVerticalSelectValue = subVerticalValue === 0 ? "" : subVerticalValue.toString();

  return (
    <>
      <FilterListItem title={title} icon={icon} open={open} tooltip={tooltip} setOpen={setOpen} selected={value.flat().length}>
        {/* {value[0]} / {verticalValue} / {subVerticalValue} */}
        <Box marginBottom={4} id="verticals-filter">
          <StyledFormControl variant="filled" disabled={isVerticalsLoading} fullWidth>
            <InputLabel id="vertical">Vertical</InputLabel>
            <Select
              labelId="vertical"
              id={`${name}-parent`}
              value={verticalSelectValue}
              onChange={handleChange}
              data-testid="verticalsDropdown"
            >
              <MenuItem key={`m1-`} value={""}>
                ---
              </MenuItem>
              {verticalsOptions.map(option => (
                <MenuItem key={`vertical${option.id}`} value={option.id}>
                  {option.title}
                </MenuItem>
              ))}
            </Select>
          </StyledFormControl>
          <StyledFormControl variant="filled" fullWidth style={{ margin: "10px 0px 10px 0px" }}>
            <InputLabel id="subvertical">Subvertical</InputLabel>
            <Select
              labelId="subvertical"
              id={`${name}-parent`}
              value={subVerticalSelectValue}
              onChange={handleChange2}
              disabled={isVerticalsLoading || listSubverticals().length === 0}
            >
              <MenuItem key={`m2-`} value={""}>
                ---
              </MenuItem>
              {listSubverticals()?.map(option => (
                <MenuItem key={`subvertical${option.id}`} value={option.id}>
                  {option.title}
                </MenuItem>
              ))}
            </Select>
          </StyledFormControl>
          <Grid container spacing={2} marginTop={7}>
            <Grid>
              <Button id={`${name}-clear`} variant="outlined" size="small" onClick={handleReset} style={{ backgroundColor: colors.white }}>
                Clear
              </Button>
            </Grid>
          </Grid>
        </Box>
      </FilterListItem>
    </>
  );
};

export default VerticalsFilter;
